import { API_BASE_URL } from '../configuration/config';
import { BaseService } from './base-service';
import { StatusCodes } from 'http-status-codes';

export interface ConversationMessage {
  text: string;
  sender: "user" | "bot";
}

export class ChatbotService extends BaseService {
  public static instance = new ChatbotService(API_BASE_URL);

  public async sendMessage(
    message: string,
    conversationHistory: ConversationMessage[]
  ): Promise<string> {
    const response = await this.fetch('/chatbot/query', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, conversationHistory }),
    });

    if (response.status !== StatusCodes.OK) {
      throw new Error(
        `Chatbot request failed with status ${response.status}`
      );
    }

    const jsonResponse = await response.json();
    return jsonResponse.response;
  }
}
